/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2024, Zumper
 */

import { autoclass, Bizo } from '@zcode/bizos'
import type { BuildingOrAddressType, RawBuildingOrAddress } from '@zcode/state-type'
import Building from './building'
import { PermanentAddress } from './permanent_address'

export const BuildingOrAddress = autoclass<BuildingOrAddressType, RawBuildingOrAddress>(
  'BuildingOrAddress',
  class BuildingOrAddress extends Bizo<BuildingOrAddressType, RawBuildingOrAddress> {},
  {
    building: { name: 'building', type: Building },
    permanentAddress: { name: 'permanent_address', type: PermanentAddress },
    hasAddress: 'has_address',
  },
  null
)
